module.exports = __webpack_public_path__ + "img/trash.f88802ad.svg";